module.exports = __webpack_public_path__ + "static/media/PF.1398e1c8.svg";